import React, { useCallback } from 'react';
import ShoppingBagIcon from '@moda/icons/shopping-bag-24';
import { useCart } from '../../hooks/useCart';
import { Link } from '../Link';
import { hrefFor } from '../../routers';
import { tc } from '../../lib/trackingContext';

import './MiniCartLink.scss';

export const MiniCartLink: React.FC = () => {
  const {
    cart: {
      attributes: { cartItemsCount }
    }
  } = useCart({ ssr: false });

  const trackHrefClick = useCallback(() => {
    tc.track('Mini Cart Icon Clicked');
  }, []);

  return (
    <Link
      className="MiniCartLink"
      onClick={trackHrefClick}
      to={hrefFor.ShoppingBagPage()}
      aria-label="Shopping Bag"
    >
      <ShoppingBagIcon />

      {cartItemsCount > 0 && `(${cartItemsCount})`}
    </Link>
  );
};
